// extracted by mini-css-extract-plugin
export var intro = "intro-module--intro--neos6";
export var logoContainer = "intro-module--logoContainer--denRA";
export var logoSlide = "intro-module--logoSlide--HGb24";
export var logoContainerFull = "intro-module--logoContainerFull--1bTHu intro-module--logoContainer--denRA";
export var introHide = "intro-module--introHide--gOcI4 intro-module--intro--neos6";
export var slideUp = "intro-module--slideUp--CLzbu";
export var slideUpLarge = "intro-module--slideUpLarge--jDxiP";